import { DetailList } from '../components/figures';
import { StepFrame } from '../components/step-frame';
import { useConsumerFlow } from '../hooks/use-consumer-flow';
import { usePlanTotals } from '../hooks/use-plan-totals';
import { money } from '../lib/format';
import type { ConsumerStepProps } from './step-props';

export function NoCareStep({ clientId }: ConsumerStepProps) {
  const { finish } = useConsumerFlow(clientId);
  const { selectedProjection, hasInsurance } = usePlanTotals(clientId);
  const deathBenefit = hasInsurance ? (selectedProjection?.deathBenefitWithoutCare ?? 0) : 0;

  return (
    <StepFrame
      step="no-care"
      title="What if you never need long-term care?"
      subtitle="There would be no long-term care claim."
      onBack={() => finish('review')}
      help={<p>The death benefit goes to your beneficiaries; it isn’t added to your care funding. Check the contract’s guarantees, surrender values and charges.</p>}
      primary={{ label: 'Back to my plan', onClick: () => finish('review') }}
    >
      <DetailList
        rows={[
          { label: 'Long-term care payments', value: money(0) },
          { label: 'Death benefit if no care is needed', value: money(deathBenefit) },
        ]}
      />
      <p className="text-muted-foreground text-sm">Personal funds stay yours, subject to spending, investment results and taxes.</p>
    </StepFrame>
  );
}
